import { render, staticRenderFns } from "./ElementPreview.vue?vue&type=template&id=4455f4a4&scoped=true&"
import script from "./ElementPreview.vue?vue&type=script&lang=ts&"
export * from "./ElementPreview.vue?vue&type=script&lang=ts&"
import style0 from "./ElementPreview.vue?vue&type=style&index=0&id=4455f4a4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4455f4a4",
  null
  
)

export default component.exports